<div style="width:100%; height: 100%; display: flex; flex-direction: column; max-height: calc(100vh - 150px); overflow: auto; margin-bottom: 70px;">
  <div data-testid="dashboard-container-view-wrapper" class="view-wrapper">
    <app-dashboard-header data-testid="dashboard-container-dashboard-header"></app-dashboard-header>
  </div>

  <div *ngIf="(dashboardData$ | async) as dashboardData; else loadingPanel">
    <div data-testid="dashboard-container-grid-container" class="grid-container">
      <div data-testid="dashboard-container-grid-item" class="grid-item" *ngFor="let table of dashboardData">
        <app-dashboard-table data-testid="dashboard-container-dashboard-table"
          [title]="table.title"
          [data]="table.data"
          [columns]="table.columns"
          (onValueClicked)="onTableValueClicked($event)">
        </app-dashboard-table>
      </div>
    </div>
  </div>

  <!-- Show loading panel if dashboardData$ is not yet resolved -->
  <ng-template #loadingPanel>
    <dx-load-panel data-testid="dashboard-container-load-panel"
      [visible]="true"
      [showPane]="false"
    ></dx-load-panel>
  </ng-template>
</div>
